import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import axios from 'axios';
import Amplify from 'aws-amplify';
import Dashboard from './bussines/dashboard/Dashboard';
import Profile from './bussines/profile/Profile';
import SignedIn from './bussines/signed-in/Signed-in';
import Search from './bussines/search/Search';
import Login from './bussines/authentication/login/Login';
import Register from './bussines/authentication/register/Register';
import UpdateRegister from './bussines/authentication/update-register/Update-register';
import ForgotPassword from './bussines/authentication/forgot-passsword/Forgot-password';
import RecoverPassword from './bussines/authentication/recover-passsword/Recover-password';
import Thanks from './bussines/thanks/Thanks';
import Processed from './bussines/authentication/processed/Processed';
import Validated from './bussines/authentication/validated/Validated';
import ResetPassword from './bussines/authentication/reset-password/Reset-password';
import ProtectedRoute from './commons/components/protected-route/Protected-route';
import UnProtectedRoute from './commons/components/protected-route/UnProtected-route';
import Loader from './commons/components/loader/Loader';
import Snackbar from './commons/components/snackbar/Snackbar';
import { AppContextProvider } from './commons/context/App-context';
import { QuestionsContextProvider } from './commons/context/Questions';
import enviroment from './enviroments/enviroment';
import './App.scss';

Amplify.configure(enviroment.awsAmplify);

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

function App() {
    return (
        <div className="App">
            <AppContextProvider>
                <Router>
                    <Switch>
                        <UnProtectedRoute
                            path="/signin"
                            component={Login}
                        ></UnProtectedRoute>
                        <UnProtectedRoute
                            path="/signup"
                            component={Register}
                        ></UnProtectedRoute>
                        <UnProtectedRoute
                            path="/processed"
                            component={Processed}
                        ></UnProtectedRoute>
                        <UnProtectedRoute
                            path="/validated"
                            component={Validated}
                        ></UnProtectedRoute>
                        <UnProtectedRoute
                            path="/reset-password"
                            component={RecoverPassword}
                        ></UnProtectedRoute>
                        <UnProtectedRoute
                            path="/recover-password"
                            component={ResetPassword}
                        ></UnProtectedRoute>
                        <UnProtectedRoute
                            path="/forgot-password"
                            component={ForgotPassword}
                        ></UnProtectedRoute>
                        <ProtectedRoute
                            path="/thanks"
                            component={Thanks}
                        ></ProtectedRoute>
                        <ProtectedRoute
                            path="/signed-in"
                            component={SignedIn}
                        ></ProtectedRoute>
                        <ProtectedRoute
                            path="/search"
                            component={Search}
                        ></ProtectedRoute>
                        <ProtectedRoute
                            path="/profile"
                            component={Profile}
                        ></ProtectedRoute>
                        <ProtectedRoute
                            path="/update-register"
                            component={UpdateRegister}
                        ></ProtectedRoute>
                        <QuestionsContextProvider>
                            <ProtectedRoute
                                path="/"
                                component={Dashboard}
                            ></ProtectedRoute>
                        </QuestionsContextProvider>
                    </Switch>
                </Router>
                <Loader />
                <Snackbar />
            </AppContextProvider>
        </div>
    );
}

export default App;
